import React from 'react';

import { DataTable } from '../../../../../shared/components/DataTable';
import { Pagination, RecordCount } from '../../../../../shared/components/Pagination';
import { SearchBar } from '../../../../../shared/components/SearchBar';
import { useReviewsRequested } from '../../hooks';
import ReviewRequestButton from '../ReviewRequestButton';
import columns from './columns';
import TableSkeleton from './TableSkeleton';

const RECORD_TYPE = 'review requests';

const ReviewsRequested = () => {
  const {
    handlePageChange,
    handleSearchChange,
    isLoading,
    pagination,
    reviewsRequested,
    searchInput,
  } = useReviewsRequested();

  return (
    <div className="flex flex-col gap-5">
      <div className="flex justify-between items-center">
        <RecordCount
          from={pagination.from}
          isLoading={isLoading}
          recordType={RECORD_TYPE}
          to={pagination.to}
          totalRecords={pagination.totalRecords}
        />

        <div className="flex gap-3 items-center">
          <ReviewRequestButton />

          <SearchBar
            className="w-80"
            disabled={isLoading}
            onChange={handleSearchChange}
            value={searchInput}
          />
        </div>
      </div>

      {isLoading ? (
        <TableSkeleton />
      ) : (
        <DataTable columns={columns} data={reviewsRequested} />
      )}

      <Pagination
        currentPage={pagination.currentPage}
        isLoading={isLoading}
        onPageChange={handlePageChange}
        totalPages={pagination.totalPages}
      />
    </div>
  );
};

export default ReviewsRequested;
